import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import {useTranslation, withTranslation} from 'react-i18next';

import customerActions from '../../Actions/customerActions'
import helpers from '../../Utils/helpers';
import commonActions from '../../Actions/commonActions'
import { useParams  } from 'react-router-dom'
import {NoInformation} from "../../Components/Panel";
import Card, {DefaultCard} from "../../Components/Card/Card";

const SentMoviesContainer = ({ customer, customerActions, sentMovies }) => {

    const { t } = useTranslation(); 
    
    useEffect(() => {
        customerActions.getSentMovies(customer.vbCustomer.customerNumber);
    }, [])

    return <DefaultCard title={t('educations.sentmovies')}>
        { sentMovies?.length > 0 &&
            <div className="table-responsive">
                <table className="table table-stripe">
                    <thead>
                    <tr>
                        <th className="text-left">{t('sentmoviescontainer.sentto')}</th>
                        <th className="text-left">{t('sentmoviescontainer.movie')}</th>
                        <th className="text-left">{t('sentmoviescontainer.datesent')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {sentMovies.map((movie, index) => {
                        return <tr key={index}>
                            <td>{movie.sentTo}</td>
                            <td>{movie.movie}</td>
                            <td>{helpers.formatDate(movie.dateSent)}</td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>}
        {sentMovies?.length === 0 && <NoInformation />}
    </DefaultCard>
}

function mapStateToProps(state) {
    return {
        sentMovies: state.CustomerReducer.sentMovies,
        customer: state.CustomerReducer.customer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SentMoviesContainer));

